import AppBar from '@material-ui/core/AppBar';
import Badge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import ApprovalsIcon from '@material-ui/icons/PlaylistAddCheck';
import { useObserver } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import FamilyMenuButton from '../families/FamilyMenuButton';
import MobxContext from '../mobx/MobxContext';
import AccountMenu from './AccountMenu';
import FaroServicesMenuButton from './FaroServicesMenuButton';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuButton: {
      marginRight: theme.spacing(2),
    },
    logo: {
      marginRight: theme.spacing(3)
    },
    iconButton: {
      marginRight: theme.spacing(2),
    },
    approvalIcon: {
      color: 'white'
    },
    navButton: {
      textTransform: 'none',
      fontWeight: 'bold',
      margin: '0 4px'
    }
  }),
);

const AdapterLink = React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
  <Link innerRef={ref as any} {...props} />
));

function AppHeader() {
  const classes = useStyles({});

  const { approvalStore } = useContext(MobxContext);

  return useObserver(() => (
    <div>
      <AppBar position="fixed">
        <Toolbar>
          <img className={classes.logo} src={`${process.env.PUBLIC_URL}/img/logo.png`} alt="logo" />
          <FamilyMenuButton />
          <FaroServicesMenuButton />
          <Button color="inherit" className={classes.navButton} component={AdapterLink} to="/groups">Groups</Button>
          <Button color="inherit" className={classes.navButton} component={AdapterLink} to="/approvals">Approvals</Button>
          <span style={{ flex: 1 }} />
          <Tooltip title="Approvals">
            <IconButton className={classes.iconButton} component={AdapterLink} to="/approvals">
              <Badge overlap='rectangular' showZero={false} badgeContent={approvalStore.pendingApprovalCount} color="secondary">
                <ApprovalsIcon className={classes.approvalIcon} />
              </Badge>
            </IconButton>
          </Tooltip>
          <AccountMenu />
        </Toolbar>
      </AppBar>
    </div >
  ));
};

export default AppHeader;
